import React from 'react'

export default function dynamic<T extends React.ComponentType<any>>(
  loader: () => Promise<{ default: T } | T>,
  _options?: any
): React.LazyExoticComponent<T> {
  // Map next/dynamic to React.lazy on the client, wrapping the result to be safe
  return React.lazy(async () => {
    const res = await loader();
    if (res && typeof res === 'object' && 'default' in res) {
      return res as { default: T };
    }
    return { default: res as T };
  })
}
